module.exports = __webpack_public_path__ + "img/gysj_h.61ac68cf.png";